import { Helmet } from "react-helmet";

export default function TwitterSeoConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    <Helmet>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@DarvinDev" />
      <meta name="twitter:creator" content="@DarvinDev" />
      <meta
        name="twitter:title"
        content="Darvin - Build Premium Mobile Apps with AI"
      />
      <meta
        name="twitter:description"
        content="AI Flutter app builder that turns text to mobile app in minutes. Build production-ready native Flutter apps for Android and iOS with no code. Try Darvin's flutter AI builder free."
      />
      <meta
        name="twitter:image"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        name="twitter:image:alt"
        content="Darvin - Build Premium Mobile Apps with AI"
      />
    </Helmet>
  ) : null;
}
